import axios from 'axios'

export default {
  baseURL: process.env.BASE_URL + 'api/localizations',

  getApplicationItemTexts(localizationId, clientId) {
    return axios.get('application-items',
      {
        baseURL: this.baseURL,
        params: {
          'localization-id': localizationId,
          'client-id': clientId ? clientId : null
        }
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  },

  getLocalizationTexts() {
    return axios.get('localization-texts',
      {
        baseURL: this.baseURL,
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  },
}
